export function PlusSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" {...props}>
      <path d="M848 474H550V152c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v322H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h290v322c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V550h298c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" />
    </svg>
  );
}
